var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _vm.label
                ? _c("base-label", { attrs: { "input-id": _vm.id } }, [
                    _vm._v("\n        " + _vm._s(_vm.label) + "\n      "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("text-field", {
                attrs: {
                  value: _vm.yearsValue,
                  validator: _vm.validator,
                  "mask-type": "number",
                  placeholder: _vm.placeholder
                    ? _vm.placeholder +
                      " (" +
                      _vm.$t("global.phrases.years") +
                      ")"
                    : _vm.$t("global.phrases.years"),
                  label: _vm.placeholder
                    ? _vm.placeholder +
                      " (" +
                      _vm.$t("global.phrases.years") +
                      ")"
                    : _vm.$t("global.phrases.years"),
                },
                on: {
                  "update:value": function ($event) {
                    _vm.yearsValue = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("text-field", {
                key: _vm.yearsValue,
                attrs: {
                  value: _vm.monthsValue,
                  validator: _vm.validator,
                  "mask-type": "number",
                  placeholder: _vm.placeholder
                    ? _vm.placeholder +
                      " (" +
                      _vm.$t("global.phrases.months") +
                      ")"
                    : _vm.$t("global.phrases.months"),
                  label: _vm.placeholder
                    ? _vm.placeholder +
                      " (" +
                      _vm.$t("global.phrases.months") +
                      ")"
                    : _vm.$t("global.phrases.months"),
                },
                on: {
                  "update:value": function ($event) {
                    _vm.monthsValue = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasWarning && _vm.warningMessage
            ? _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "12" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "validation-error",
                      class: { "soft-error": _vm.hasWarning },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.warningMessage) + "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }